import api from './api';

export default {
	update,
};

function update(password) {
	return api.update('password', password.user_id, password);
}
